/* global propel */
import { Loader } from '@googlemaps/js-api-loader';

let loaded = false;
const maps = document.querySelectorAll(
	'.block-filter-locations__map, .block-hero-map__map'
);

const loadGoogleMaps = () => {
	if (loaded) {
		return;
	}

	loaded = true;

	document.removeEventListener('scroll', loadGoogleMaps);
	document.removeEventListener('mousemove', loadGoogleMaps);
	document.removeEventListener('touchstart', loadGoogleMaps);

	if (propel.googleApiKey) {
		const loader = new Loader({
			apiKey: propel.googleApiKey,
			version: 'weekly',
		});

		loader.importLibrary('maps').then(() => {
			const loadedEvent = new Event('google-maps-loaded');
			window.dispatchEvent(loadedEvent);
		});
	}
};

document.addEventListener('scroll', loadGoogleMaps);
document.addEventListener('mousemove', loadGoogleMaps);
document.addEventListener('touchstart', loadGoogleMaps);

maps.forEach((map) => {
	const observer = new IntersectionObserver(
		(entries, obs) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					loadGoogleMaps();
					obs.unobserve(entry.target);
				}
			});
		},
		{
			root: null,
			rootMargin: '0px 0px 0px 0px',
			threshold: [0],
		}
	);
	observer.observe(map);
});

const blocks = document.querySelectorAll(
	'.block-filter-locations, .block-hero-map'
);

if (blocks.length > 0 && window.innerWidth >= 768) {
	window.addEventListener('load', loadGoogleMaps);
}
